// @ts-check
import { defineConfig } from '../utils';

export function traceability() {
  return defineConfig({
    properties: {
      'Trazabilidad.Alertas.FiltrarPorLineaYPuntoPaletizadoSeleccionado': {
        defaultValue: true,
      },
      'Trazabilidad.Alertas.MostrarAlertasPedidosModificados': {
        defaultValue: true,
      },
      'Trazabilidad.Alertas.PlanificacionesYDesplanificaciones': {
        defaultValue: true,
      },
    },
  });
}
